"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.virtualPageView = exports.onPageLoadEvent = void 0;
const initialize_1 = require("../initialize");
function onPageLoadEvent() {
    /* Track a page view */
    initialize_1.default.page();
}
exports.onPageLoadEvent = onPageLoadEvent;
function virtualPageView(page) {
    initialize_1.default.track("gtm.pageview", { pageview: page });
    initialize_1.default.track("gtm.ga4pageview", { pageview: page });
}
exports.virtualPageView = virtualPageView;
